import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import axios from "axios";
import { api } from "../utils/Api";
import { Button, Result } from "antd";

const ClientConfirmation = ({ match, history }) => {
	const [customerNumber, setCustomerNumber] = useState("");
	const [name, setName] = useState("");

	useEffect(() => {
		const getClient = async () => {
			const url = api + "/customer/" + match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			try {
				const { data } = await axios.get(url);
				setCustomerNumber(data.customerNumber);
				setName(data.name);
			} catch (err) {
				console.error(err.message);
				return null;
			}
		};
		getClient();
	}, [match]);

	const navigateUrl = (key) => {
		switch (key) {
			case "daily":
				history.push("/dailyappointment");
				break;
			case "client":
				history.push("/client/list");
				break;
			case "edit":
				history.push(`/customer/profile/${match.params.id}`);
				break;
			default:
				break;
		}
	};

	return (
		<Layout title="" description="">
			<Result
				status="success"
				title="Successfully Customer Registration"
				subTitle={`Customer Number: ${customerNumber}, Name: ${name}`}
				extra={[
					<Button
						type="primary"
						size="large"
						key="daily"
						onClick={() => navigateUrl("daily")}
					>
						Go Daily Appointment
					</Button>,
					<Button
						key="client"
						size="large"
						onClick={() => navigateUrl("client")}
					>
						Go Customer List
					</Button>,
					<Button
						type="primary"
						key="edit"
						size="large"
						onClick={() => navigateUrl("edit")}
					>
						View Customer
					</Button>,
				]}
			/>
		</Layout>
	);
};

export default ClientConfirmation;
